<template>
    <div>
        <div class="hidden sm:flex justify-center">
            <div v-for="(item,index) in menus" :key="index" class="cursor-pointer text-20">
                <div v-if="item.keyword !== 'logout'" @click="onclickMenu(item)">
                    <span class="px-2 text-tc-gray-3" v-if="item.keyword == 'lang'" @click="changeLang()">{{ item.text }}</span>
                    <span v-else class="px-2 text-tc-gray-3">{{ item.text }}</span>
                    <span class="px-2 text-tc-gray-5">|</span>
                </div>
            </div>
        </div>
        <div class="sm:hidden" v-for="(item,index) in menus" :key="index">
            <div class="px-5">
                    <div class="flex justify-between py-3" :class="item.keyword !== 'cancel-member' ? 'border-b-2 border-a-gray-d7dced' : ''">
                        <div class="cursor-pointer text-20">
                            <!-- <div v-if="item.keyword === 'cancel-member'" class="text-666666 text-18" @click="cancelMember()">{{ item.text }}</div> -->
                            <div class="py-1 text-a-blue-1c3e95" @click="onclickMenu(item)">{{ item.text }}</div>
                        </div>
                        <div class="cursor-pointer">
                            <div class="w-24 h-8" v-if="item.keyword === 'lang'">
                                <SwitchLang></SwitchLang>
                            </div>
                            <div v-if="item.keyword !== 'lang'" class="w-20" @click="onclickMenu(item)">
                                <img class="pt-2 ml-auto" src="@/assets/icon/next.svg" />
                            </div>
                        </div>
                </div>
            </div>
        </div>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>

<script>
//helper
import Account from "@/helper/AccountHelper.js";
import ModalMixin from '@/mixin/ModalMixin';
import SwitchLang from '@/components/Input/simple/SwitchLang.vue';
import CacheHelper from '@/helper/CacheHelper'
import LocaleMixin from '@/mixin/LocaleMixin';

export default {
    components:{
        SwitchLang,
    },
    name: 'MenuTermandcondition',
    props:{
        controller: Object
    },
    mixins: [ModalMixin, LocaleMixin],
    data: function() {
        return {
            loginChanel: '',
            menus: []
        };
    },
    created: function(){
        this.getCacheBzbsUser();
        this.menus = [
                {
                    text: this.lbl.profile.privacy_policies,
                    path: '/termandcondition?type=readonly',
                    keyword: 'terms'
                },
                {
                    text: this.lbl.profile.term_cons,
                    path: '/termandcondition?type=readonly',
                    keyword: 'privacy'
                },
                {
                    text: this.lbl.profile.contact_us,
                    path: '/contactus',
                    keyword: 'contact-us'
                },
                {
                    text: this.lbl.profile.language,
                    path: '',
                    keyword: 'lang'
                },
                {
                    text: this.lbl.profile.sing_out,
                    path: '',
                    keyword: 'logout'
                },
                // {
                //     text: this.lbl.profile.delete_user,
                //     path: '',
                //     keyword: 'cancel-member'
                // },
            ]
    },
    methods: {
        isShowTextMenu: function(item){
            if(this.loginChanel === 'line'){ //login ด้วย line ไม่ต้องแสดงปุ่ม logout
                if(item.keyword === 'logout'){
                    return false
                }else{
                    return true
                }
            }
            return true
        },
        getCacheBzbsUser: function(){
            let userData = Account.getCacheUser();
            if(userData){
                this.loginChanel = userData.loginChanel;
            }
        },
        onclickMenu: function(item){
            if(item.keyword === 'logout'){
                this.logout();
            }else{
                this.$router.push(item.path)
            }
        },
        logout: async function(){
            this.modalController.confirmModal
                    .clearModal()
                    .setTitle(this.lbl.profile.sing_out_confirm)
                    .setMsg(this.lbl.profile.want_sing_out)
                    .setBtnOk(this.lbl.profile.confirm)
                    .show()
            this.modalController.confirmModal.onClickOk (() => {
                this.controller.loadingModal.show();
                Account.setLogout();
                let cache = new CacheHelper('local');
                cache.removeCache('register_channel');
                window.location.replace('/home')
                this.controller.loadingModal.hide();
            });
        },
        cancelMember: function(){
            console.log('ยกเลิกสมาชิก')
        },
        changeLang: function(){
            let lang = this.localeCode == 1054 ? 1033 : 1054;
            this.switchLang(lang);
        }
    },
};
</script>

<style lang="scss" scoped>

</style>
